import React from 'react';
import { Download, QrCode, Smartphone, CheckCircle } from 'lucide-react';

const DownloadSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Main Content */}
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
              Ready to Transform Your Calling Process?
            </h2>
            <p className="text-xl text-primary-100 mb-8 leading-relaxed">
              Download Bulk Leads Caller today and streamline your calling sessions.
            </p>

            {/* Download Buttons */}
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
              <button className="bg-white text-primary-600 px-8 py-4 rounded-lg hover:bg-gray-50 transition-all duration-200 flex items-center space-x-3 text-lg font-semibold shadow-lg hover:shadow-xl">
                <Download className="w-6 h-6" />
                <span>Download for Android</span>
              </button>
              
              <div className="text-white text-sm">
                <p>Coming Soon</p>
                <p className="text-primary-200">iOS Version</p>
              </div>
            </div>

            {/* QR Code Section */}
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-md mx-auto">
              <div className="text-center">
                <div className="w-32 h-32 bg-white rounded-lg mx-auto mb-4 flex items-center justify-center">
                  <QrCode className="w-24 h-24 text-primary-600" />
                </div>
                <p className="text-white font-medium mb-2">Scan to Download</p>
                <p className="text-primary-200 text-sm">Point your camera at the QR code</p>
              </div>
            </div>
          </div>

          {/* Features List */}
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Free to Use</h3>
              <p className="text-primary-100 text-sm">No subscription required. Download and start calling immediately.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Smartphone className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Mobile Optimized</h3>
              <p className="text-primary-100 text-sm">Built with Flutter for the best mobile experience.</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Offline Ready</h3>
              <p className="text-primary-100 text-sm">Works without internet connection for uninterrupted calling.</p>
            </div>
          </div>

          {/* System Requirements */}
          <div className="mt-12 bg-white/10 backdrop-blur-sm rounded-xl p-6 max-w-2xl mx-auto">
            <h3 className="text-lg font-semibold text-white mb-4">System Requirements</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-primary-100">
              <div>
                <p><strong>Platform:</strong> Android 6.0+</p>
                <p><strong>Storage:</strong> 50MB free space</p>
              </div>
              <div>
                <p><strong>RAM:</strong> 2GB minimum</p>
                <p><strong>Permissions:</strong> Phone, Storage</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;
